import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_checkbox_input = _resolveComponent("oxd-checkbox-input")!
  const _component_oxd_card_th = _resolveComponent("oxd-card-th")!
  const _component_oxd_card_tr = _resolveComponent("oxd-card-tr")!
  const _component_oxd_card_thead = _resolveComponent("oxd-card-thead")!

  return (_ctx.showHeader)
    ? (_openBlock(), _createBlock(_component_oxd_card_thead, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_oxd_card_tr, { clickable: false }, {
            default: _withCtx(() => [
              (_ctx.tableProps.selectable)
                ? (_openBlock(), _createBlock(_component_oxd_card_th, {
                    key: 0,
                    class: _normalizeClass(["oxd-padding-cell oxd-table-th", _ctx.tableProps.selector.class]),
                    style: _normalizeStyle(_ctx.tableProps.selector.style)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oxd_checkbox_input, {
                        checkIcon: _ctx.checkIcon,
                        modelValue: _ctx.selectedAll,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAll) = $event)),
                        onChange: _ctx.onChangeSelectAll
                      }, null, 8, ["checkIcon", "modelValue", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["class", "style"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableProps.headers, (header) => {
                return (_openBlock(), _createBlock(_component_oxd_card_th, {
                  class: _normalizeClass(["oxd-padding-cell oxd-table-th", header.class]),
                  key: header,
                  style: _normalizeStyle(header.style),
                  order: _ctx.tableProps.order[header.sortField],
                  onOrder: ($event: any) => (_ctx.onColumnOrderChanged($event, header))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(header.title), 1)
                  ]),
                  _: 2
                }, 1032, ["style", "class", "order", "onOrder"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}